module.exports = __webpack_public_path__ + "static/media/lascalles02_small@3x.aaf0d98b.jpg";